import React from "react";
import { levelOf } from "@/lib/levels";

export const LevelRing = ({ xp = 0, size = 36 }) => {
  const lv = levelOf(xp);
  const r = (size - 8) / 2;
  const c = 2 * Math.PI * r;
  const tip = lv.next
    ? `${lv.title} — ${lv.pct}% of the way to ${lv.next.title} (${xp.toLocaleString()} lifetime coins)`
    : `${lv.title} — max level! (${xp.toLocaleString()} lifetime coins)`;
  return (
    <div className="relative shrink-0" title={tip} data-testid="header-level-ring">
      <svg width={size} height={size} className="-rotate-90 block">
        <circle cx={size / 2} cy={size / 2} r={r} fill="#FFFFFF" stroke="#C4C8CE" strokeWidth="3.5" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={lv.color} strokeWidth="3.5"
          strokeDasharray={c} strokeDashoffset={c * (1 - lv.pct / 100)} strokeLinecap="round" />
      </svg>
      <span className="absolute inset-0 grid place-items-center font-display font-extrabold text-xs pointer-events-none"
        style={{ color: lv.color }} data-testid="header-level-letter">
        {lv.title === "Self-Agent" ? "★" : lv.title[0]}
      </span>
    </div>
  );
};
